/* eslint-disable */

//tslint:disable

export var EStatus = /*#__PURE__*/function (EStatus) {
  /** Удачно **/
  EStatus["Success"] = "success";
  /** Код введён некорректно **/
  EStatus["Wrong"] = "wrong";
  /** Необходимо ввести пароль **/
  EStatus["CheckPassword"] = "checkPassword";
  /** Превышен лимит ввода кода **/
  EStatus["CodeInputLimitReached"] = "codeInputLimitReached";
  /** Истекло время действия проверочного кода **/
  EStatus["CodeExpired"] = "codeExpired";
  /** Множество аккаунтов **/
  EStatus["ManyAccounts"] = "manyAccounts";
  return EStatus;
}({});